import {
  Flex,
  useMantineTheme,
  Text,
  ActionIcon,
  Group,
  Button,
  List,
  Box,
} from "@mantine/core";
import { closeModal } from "@mantine/modals";
import { useContext } from "react";
import { MdClose } from "react-icons/md";
import { AppContext } from "src/api/AppContext";
import {
  UnsavedMethod,
  useCatalogContext,
} from "src/api/context/CatalogContext";
import { useGetTerminalsByLocationQuery } from "src/generated/graphql";
import { ModalId } from "src/utils/constants";

type ITerminal = {
  onClose: () => void;
};

function Terminal({ onClose }: ITerminal) {
  const theme = useMantineTheme();
  const color = theme.colors.secondaryTextColor[6];
  const {
    selectedTerminalId,
    setselectedTerminalId,
    setSelectedUnsavedMethod,
  } = useCatalogContext();
  const { currentLocation } = useContext(AppContext);

  const { data: terminalData } = useGetTerminalsByLocationQuery({
    variables: { locationId: currentLocation?.id },
    skip: !currentLocation,
    fetchPolicy: "no-cache",
  }); // here is where you need to get the terminals and peel out the terminals to be used below

  const handleSelect = () => {
    onClose();
  };

  return (
    <>
      <Flex
        align={"center"}
        justify={"space-between"}
        style={{
          paddingBottom: "10px",
          marginBottom: "10px",
          borderBottom: `2px solid ${theme.colors.light[5]}`,
        }}
      >
        <Text size={22} fw={500}>
          Select Terminal
        </Text>
        <ActionIcon
          size="lg"
          onClick={() => closeModal(ModalId.SelectTerminal)}
        >
          <MdClose size={20} />
        </ActionIcon>
      </Flex>

      <List
        my={10}
        styles={{
          itemWrapper: {
            width: "100%",
          },
          item: {
            listStyle: "none",
            cursor: "pointer",
            gap: 10,
            //borderBottom: "1px solid #dddddd",
          },
        }}
      >
        {terminalData?.paymentTerminalMany?.map((t) => {
          return (
            <List.Item
              sx={{
                background:
                  selectedTerminalId === t.id
                    ? theme.colors.primary[3]
                    : theme.colors.primary[5],
                borderRadius: 30,
                alignContent: "center",
              }}
              key={t.id}
              p={10}
              onClick={() => {
                setselectedTerminalId(t.id);
                setSelectedUnsavedMethod(UnsavedMethod.Terminal);
              }}
            >
              <Text
                size={14}
                c={theme.colors.primaryTextColor[5]}
                style={{ paddingLeft: 10 }}
                weight={500}
              >
                {t.name}
              </Text>
            </List.Item>
          );
        })}
      </List>

      <Box
        style={{
          position: "absolute",
          bottom: 10,
          left: 0,
          width: "100%",
          margin: "auto",
        }}
      >
        <Group>
          <Button
            fullWidth
            mt={"xs"}
            radius={"xl"}
            size="sm"
            ml={"sm"}
            sx={{ color, ":hover": { color: "white" } }}
            onClick={onClose}
          >
            Back
          </Button>
          <Button
            fullWidth
            mt={"xs"}
            mr={"sm"}
            radius={"xl"}
            size="sm"
            onClick={handleSelect}
            disabled={!selectedTerminalId}
          >
            Select
          </Button>
        </Group>
      </Box>
    </>
  );
}

export default Terminal;
